import { Swiper, SwiperSlide } from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", function(event) {
    const blogSwiperElements = document.querySelectorAll(".blogSwiper");

    blogSwiperElements.forEach(function(element) {
        const slidesPerView = element.closest(".blog-swiper-attr").getAttribute('data-slide');
        const autoplay = element.closest(".blog-swiper-attr").getAttribute('data-autoplay');
        const loop = element.closest(".blog-swiper-attr").getAttribute('data-loop');
        const speed = element.closest(".blog-swiper-attr").getAttribute('data-speed');
        const navigation = element.closest(".blog-swiper-attr").getAttribute('data-navigation');

        let navigation_obj = {};
        if (navigation) {
            navigation_obj = {
                nextEl: element.closest(".blog-swiper-attr").querySelector(".swiper-button-next"),
                prevEl: element.closest(".blog-swiper-attr").querySelector(".swiper-button-prev"),
            }
        }

        const swiper = new Swiper(element, {
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: (slidesPerView ? slidesPerView : 2),
            spaceBetween: 24,
            loop: (loop ? loop : true),
            speed: (speed ? speed : 2000),
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },

            navigation: navigation_obj,
            autoHeight: true,
            mousewheel: true,
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                100: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: (slidesPerView ? slidesPerView : 2),
                },
            }
        });

        // Remove navigation elements if navigation is disabled
        if (!navigation) {
            let nextEl = element.closest(".blog-swiper-attr").querySelector(".swiper-button-next");
            let prevEl = element.closest(".blog-swiper-attr").querySelector(".swiper-button-prev");
            if (nextEl) nextEl.remove();
            if (prevEl) prevEl.remove();
        }
    });
});
